/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { useMemo } from 'react';
import { useState } from 'react';
import { useRef } from 'react';
import { useCallback } from 'react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import createDatasource from './ServerSideDatasource';
import { PermissionsContext } from 'contexts/PermissionsContext';
import { Content, Wrapper } from './ExploreLibrary.styles';
import { SettingsContext } from 'contexts/SettingsContext';

const ExploreLibrary = () => {
	const COLUMNS_VENDOR_LIBRARY = [
		{
			headerName: 'AP L1Category',
			field: 'AP_L1Category',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'AP_L1Category',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'AP L2Category',
			field: 'AP_L2Category',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'AP_L2Category',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'AP L3Category',
			field: 'AP_L3Category',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'AP_L3Category',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'AP L4Category',
			field: 'AP_L4Category',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'AP_L4Category',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'Vendor Name',
			field: 'NormalizedVendorName',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'NormalizedVendorName',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'Spend',
			field: 'Spend',
			filterParams: {
				filterOptions: [
					'equals',
					'notEqual',
					'lessThan',
					'lessThanOrEqual',
					'greaterThan',
					'greaterThanOrEqual',
				],
			},
			colId: 'Spend',
			filter: 'agNumberColumnFilter',
			sort: 'desc',
			sorted: true,
		},
		{
			headerName: 'Region',
			field: 'ClientLocation',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'ClientLocation',
			filter: 'agTextColumnFilter',
		},
	];
	const gridStyle = useMemo(
		() => ({
			height: '375px',
			width: '100%',
		}),
		[]
	);
	const defaultColDefs = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
		};
	}, []);
	const gridRef = useRef();
	const { hideDecimals } = useContext(SettingsContext);
	const [columnDefs] = useState(COLUMNS_VENDOR_LIBRARY);
	const [gridOptions] = useState({
		modules: AllModules,
		columnDefs: columnDefs,
		cacheBlockSize: 200,
		maxBlocksInCache: 10,
		enableColResize: true,
		enableSorting: true,
		enableFilter: true,
		rowModelType: 'serverSide',
		floatingFilter: true,
		maxConcurrentDatasourceRequests: 1,
		multiSortKey: 'ctrl',
		suppressCutToClipboard: true,
	});

	const onGridReady = useCallback(
		params => {
			gridRef.current.api.startEditingCell(params);
			const gridOptionsnew = {
				columnDefs,
				suppressRowClickSelection: true,
				...gridOptions,
			};
			const datasource = createDatasource(
				gridOptionsnew,
				params.columnApi,
				params.api,
				hideDecimals
			);
			params.api.setServerSideDatasource(datasource);
		}, //eslint-disable-next-line
		[columnDefs, gridOptions]
	);

	return (
		<Wrapper>
			<Content>
				<div style={gridStyle} className="ag-theme-balham">
					<AgGridReact
						ref={gridRef}
						modules={AllModules}
						columnDefs={columnDefs}
						cacheBlockSize={200}
						defaultColDef={defaultColDefs}
						maxBlocksInCache={10}
						enableColResize={true}
						enableSorting={true}
						enableFilter={true}
						rowModelType="serverSide"
						maxConcurrentDatasourceRequests={1}
						multiSortKey="ctrl"
						onGridReady={onGridReady}
					/>
				</div>
			</Content>
		</Wrapper>
	);
};

export default props => (
	<PermissionsContext.Consumer>
		{({ permissions }) => (
			<ExploreLibrary {...props} permissions={permissions || []} />
		)}
	</PermissionsContext.Consumer>
);
